import { render, staticRenderFns } from "./MessageThreadsView.vue?vue&type=template&id=5e388e89&scoped=true&"
import script from "./MessageThreadsView.vue?vue&type=script&lang=ts&"
export * from "./MessageThreadsView.vue?vue&type=script&lang=ts&"
import style0 from "./MessageThreadsView.vue?vue&type=style&index=0&id=5e388e89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e388e89",
  null
  
)

export default component.exports